// FETCH ALL STYLE_PRE_DIA
export const FETCH_STYLE_PRE_DIA_REQUEST = 'FETCH_STYLE_PRE_DIA_REQUEST';
export const FETCH_STYLE_PRE_DIA_SUCCESS = 'FETCH_STYLE_PRE_DIA_SUCCESS';
export const FETCH_STYLE_PRE_DIA_FAILURE = 'FETCH_STYLE_PRE_DIA_FAILURE';

export const FETCH_STYLE_PRE_DIA_BY_PART_REQUEST = 'FETCH_STYLE_PRE_DIA_BY_PART_REQUEST';
export const FETCH_STYLE_PRE_DIA_BY_PART_SUCCESS = 'FETCH_STYLE_PRE_DIA_BY_PART_SUCCESS';
export const FETCH_STYLE_PRE_DIA_BY_PART_FAILURE = 'FETCH_STYLE_PRE_DIA_BY_PART_FAILURE';

// FETCH ALL STYLE_PRE_DIA
export const FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_REQUEST = 'FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_REQUEST';
export const FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_SUCCESS = 'FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_SUCCESS';
export const FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_FAILURE = 'FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_FAILURE';

// FETCH ALL STYLE_PRE_DIA
export const FETCH_STYLE_PRE_ALL_DIA_REQUEST = 'FETCH_STYLE_PRE_ALL_DIA_REQUEST';
export const FETCH_STYLE_PRE_ALL_DIA_SUCCESS = 'FETCH_STYLE_PRE_ALL_DIA_SUCCESS';
export const FETCH_STYLE_PRE_ALL_DIA_FAILURE = 'FETCH_STYLE_PRE_ALL_DIA_FAILURE';

// CREATE STYLE_PRE_DIA
export const CREATE_STYLE_PRE_DIA_REQUEST = 'CREATE_STYLE_PRE_DIA_REQUEST';
export const CREATE_STYLE_PRE_DIA_SUCCESS = 'CREATE_STYLE_PRE_DIA_SUCCESS';
export const CREATE_STYLE_PRE_DIA_FAILURE = 'CREATE_STYLE_PRE_DIA_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_STYLE_PRE_DIA_REQUEST = 'FETCH_SINGLE_STYLE_PRE_DIA_REQUEST';
export const FETCH_SINGLE_STYLE_PRE_DIA_SUCCESS = 'FETCH_SINGLE_STYLE_PRE_DIA_SUCCESS';
export const FETCH_SINGLE_STYLE_PRE_DIA_FAILURE = 'FETCH_SINGLE_STYLE_PRE_DIA_FAILURE';

// UPDATE STYLE_PRE_DIA
export const UPDATE_STYLE_PRE_DIA_REQUEST = 'UPDATE_STYLE_PRE_DIA_REQUEST';
export const UPDATE_STYLE_PRE_DIA_SUCCESS = 'UPDATE_STYLE_PRE_DIA_SUCCESS';
export const UPDATE_STYLE_PRE_DIA_FAILURE = 'UPDATE_STYLE_PRE_DIA_FAILURE';

// DELETE STYLE_PRE_DIA
export const DELETE_STYLE_PRE_DIA_REQUEST = 'DELETE_STYLE_PRE_DIA_REQUEST';
export const DELETE_STYLE_PRE_DIA_SUCCESS = 'DELETE_STYLE_PRE_DIA_SUCCESS';
export const DELETE_STYLE_PRE_DIA_FAILURE = 'DELETE_STYLE_PRE_DIA_FAILURE';

export const RESET_STYLE_PRE_DIA_INFO = 'RESET_STYLE_PRE_DIA_INFO';

export const CREATE_STYLE_PRE_DIA_FORM = 'CREATE_STYLE_PRE_DIA_FORM';

export const UPDATE_STYLE_PRE_DIA_FORM = 'UPDATE_STYLE_PRE_DIA_FORM';


